import classNames from 'classnames'
import styles from 'sections/product-info/ProductInfo.module.scss'
import { Button } from '@boltenergy-be/design-system'
import { ProductInfoSectionProps } from 'sections/product-info/types'
import BlocksRenderer from 'components/blocks-renderer/BlocksRenderer'
import { Heading, Img } from '@boltenergy-be/design-system'

const ProductInfo = ({ isDark, startRegistration, contentBlocks, product }: ProductInfoSectionProps) => {
  return (
    <section id="info-section" className={classNames('section', { ['is-dark']: isDark }, styles['product-info-section'])}>
      <div className="container">
        <Heading as="h2" variant="d3" className="mb-400">
          {contentBlocks.title}
        </Heading>
        <div className={styles['info-blocks-layout']}>
          {contentBlocks.content.map(({ text, buttonText, image, id }) => (
            <div className={styles['info-block']} key={id}>
              <div className={styles.content}>
                <BlocksRenderer
                  content={text}
                  blocks={{
                    heading: ({ children }) => (
                      <Heading as="h3" variant="h4" serif>
                        {children}
                      </Heading>
                    )
                  }}
                />

                {buttonText && (
                  <Button onClick={() => startRegistration(product)} className="mt-400">
                    {buttonText}
                  </Button>
                )}
              </div>

              {image?.url && (
                <picture className={styles['image-wrapper']}>
                  <Img publicId={image.provider_metadata.public_id} fill alt="" objectFit="contain" objectPosition="top" />
                </picture>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ProductInfo
